import { useCallback, useState } from "react";
import { CompanyInterface, HeaderDashboardKey, HeaderDashboardStoreInterface } from "../model/HeaderDashboardStore.model";

const useHeaderDashboardStore = (): HeaderDashboardStoreInterface => {
  const [loading, setLoadingState] = useState<Record<HeaderDashboardKey, boolean>>({
    companies: false,
  });
 
  const [error, setErrorState] = useState<Record<HeaderDashboardKey, string | null>>({
    companies: null,
  });

  const setLoading = useCallback((key: HeaderDashboardKey, v: boolean) => {
    setLoadingState(prev => ({ ...prev, [key]: v }));
  }, []);

  const setError = useCallback((key: HeaderDashboardKey, e: string | null) => {
    setErrorState(prev => ({ ...prev, [key]: e }));
  }, []);

  const [companies, setCompanies] = useState<CompanyInterface[]>([]);
  const [selectedPlan, _setSelectedPlan] = useState<number | null>(null);
  const [openEditPlanPopup, setOpenEditPlanPopup] = useState<boolean>(false);
  const [selectedCompanysPlan, _setSelectedCompanysPlan] = useState<number | null>(null);
  const [openEditCompanysPlanPopup, setOpenEditCompanysPlanPopup] = useState<boolean>(false);
  
  const setSelectedPlan = useCallback((plan: number | null) => {
    
    if (plan) {
      _setSelectedPlan(plan);
      setOpenEditPlanPopup(true);
    } else {
      _setSelectedPlan(null);
      setOpenEditPlanPopup(false);
    }
  }, [])

  const setSelectedCompanysPlan = useCallback((plan: number | null) => {
    if (plan) {
      _setSelectedCompanysPlan(plan);
      setOpenEditCompanysPlanPopup(true);
    } else {
      _setSelectedCompanysPlan(null);
      setOpenEditCompanysPlanPopup(false);
    }
  }, [])

  return {
    loading, setLoading,
    error, setError,
    companies, setCompanies,
    selectedPlan, setSelectedPlan,
    openEditPlanPopup,
    openEditCompanysPlanPopup, 
    selectedCompanysPlan, setSelectedCompanysPlan,
  }
}

export default useHeaderDashboardStore;
